<template>
  <div class="animated fadeInUp" id="dashboard">
    <!-- <div class="section is-relative mockup-section"> -->
    <div class="section">
      <div class="d-none d-md-block">
        <h3 class="text-bold mb-5">Vendor</h3>
        <!-- search bar -->
        <p class="text-left">
          <router-link to="/vendors" class="text-hard-bold text-dark" active-class="current">Vendor</router-link>
          <i class="fas fa-chevron-right mx-4"></i> 
          Vendor Details
        </p>
      </div>
      <MobileBreadCrumb :title="'Vendor Detail'" />
      <div class="has-text-centered">
          <div class="has-text-centered">
            <div class="pt-20 pb-50">
              <div class="z-index-2">
                <div class="hr-content">
                  <div class="row mb-5" v-if="customer_account">
                    <div class="col-12 col-lg-8">
                      <div class="rounded bg-light shadow">
                        <div class="p-3">
                          <div class="row">
                            <div class="col-12 col-md-6 text-left mb-4">
                              <span class="text-hard-bold">Vendor</span>
                              <p class="mb-0 mt-1 text-break">{{ customer_account.name }}</p>
                            </div>
                            <div class="col-12 col-md-6 text-left mb-4">
                              <span class="text-hard-bold">Email</span>
                              <p class="mb-0 mt-1 text-break" v-if="customer_account.email">{{ customer_account.email }}</p>
                              <p class="mb-0 mt-1 text-break" v-else>No email available</p>
                            </div>
                            <div class="col-12 col-md-6 text-left mb-4">
                              <span class="text-hard-bold">Location</span>
                              <p class="mb-0 mt-1" v-if="customer_account.address">{{ customer_account.address }}</p>
                              <p class="mb-0 mt-1" v-else>no location available</p>
                            </div>
                            <div class="col-12 col-md-6 text-left mb-4">
                              <span class="text-hard-bold">Phone</span>
                              <p class="mb-0 mt-1 text-break" v-if="customer_account.phone_number">{{ customer_account.phone_number }}</p>
                              <p class="mb-0 mt-1 text-break" v-else>No phone number available</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="px-3">
                    <div class="row text-left">
                      <div class="col-9 pl-0 d-none d-md-block">
                        <h2>Transactions</h2>
                      </div>
                    </div>

                    <table-filters 
                      :hidePayers="true"
                      @filtersSubmit="filtersSubmit"
                      @reset="clear"
                    />
                  </div>

                  <b-table 
                    class="d-none d-md-inline-table"
                    ref="table"
                    id="my-table" 
                    hover 
                    head-variant="dark"
                    :items="payerVendorTransactions" 
                    :fields="masterTableProps.fields" 
                    :per-page="masterTableProps.resultsPerPage"
                    :current-page="masterTableProps.currentPage"
                    :filter="filter"
                    :filter-function="filterTable"
                    :sort-by.sync="masterTableProps.sortBy"
                    :sort-direction="masterTableProps.sortDirection"
                    :sort-desc.sync="masterTableProps.sortDesc"
                    show-empty
                    @filtered="onFiltered"
                    :busy="payerVendorTransactionsIsReady"
                  >
                    <template #empty>
                      <empty-table></empty-table>
                    </template>
                    <template #table-busy>
                      <div style="display:flex; justify-content: center">
                        <spinner></spinner>
                      </div>
                    </template>
                    <template #cell(created_at)="data">
                      {{ new Date(data.item.created_at) | dateFormat('DD/MM/YYYY h:mm A') }}
                    </template>
                    <!-- <template #cell(service_reference)="data">
                      <a class="text-link">{{ data.item.service_reference }}</a>
                    </template> -->
                    <template #cell(transaction_amount)="data">
                      {{ data.item.currency }} {{ data.item.transaction_amount | currency }}
                    </template>
                  </b-table>

                  <mobile-transaction
                    :transactions="payerVendorTransactions"
                    :loading="payerVendorTransactionsIsReady"
                    :limit="10"
                    :search="search"
                    :filter="filter_mobile"
                  />

                  <table-pagination
                    :totalRows="rows"
                    @paginationChange="handlePaginationChange"
                  />

                  <!-- <b-pagination
                    v-show="rows > 1"
                    v-model="masterTableProps.currentPage"
                    :total-rows="rows"
                    :per-page="masterTableProps.resultsPerPage"
                    aria-controls="my-table"
                    hide-goto-end-buttons
                    hide-ellipsis
                    prev-text="Prev"
                    next-text="Next"
                    class="d-none d-md-flex justify-content-start"
                  ></b-pagination> -->
                </div>
              </div>
              
              <!-- <modal name="payer-details" :adaptive="true" :minWidth="800">
                <PayerDetails />
              </modal> -->
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
// TODO: copy header modal component thing into here
//import PayerDetails from '../components/Payer-Detail.vue';
import store from '../store';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import EmptyTable from '../utils/empty-table.vue';
import MobileTransaction from '../components/MobileTransaction.vue';
import MobileBreadCrumb from '../components/MobileBreadCrumb.vue';
import TablePagination from '../components/TablePagination.vue';
import TableFilters from '../components/TableFilters.vue';
import TransactionAPI from '../api/transactions_api';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    spinner,
    EmptyTable,
    MobileTransaction,
    MobileBreadCrumb,
    TablePagination,
    TableFilters
  },
  data() {
    return {
      filter_mobile: {},
      search: '',
      authenticated: '',
      headerTag: {
        'animated fadeIn': false,
        hidden: true,
      },
      loggedInUser: {},
      filterTerm: '',
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        isBusy: false,
        sortDesc: true
      },
      masterFilterProps: {
        filterIndexes: [],
        filters: {
          numberFilter: null,
          startDate: '',
          endDate: ''
        }
      }
    };
  },
  props: ['session'],
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
    this.init();
  },
  mounted() {
    this.tokenizer();
    //this.$root.$emit('showMenu');
    // setTimeout(() => {
    //   this.headerTag = {
    //     'animated fadeInUp': true,
    //     hidden: false,
    //   };
    //   setTimeout(() => {
    //     this.headerTag = {
    //       'animated fadeInDown': false,
    //       hidden: false,
    //     };
    //     this.getCurrentUser();
    //   }, 1500);
    // }, 100);
  },
  methods: {
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
        // window.location.href = './dashboard';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
      }
    },
    init() {
      const self = this;
      const id = this.$route.params.id;
    },
    filterTable(row, filter) {
      // TODO: deprecate this
      var buildQuery = [];

      this.masterFilterProps.filterIndexes.forEach(function(value, index, array) {
        // if (value == 0) {
        //   // TODO: put table rowRelatesTo: property into filters
        //   buildQuery.push('row.payer_account.name.includes(filter[0])');
        // }

        if (value == 0) {
          buildQuery.push('row.service_reference.includes(filter[0])');
        }

        if (value == 1) {
          buildQuery.push('new Date(row.created_at) >= new Date(filter[1])');
        }

        if (value == 2) {
          buildQuery.push('new Date(row.created_at) <= new Date(filter[2])');
        }
      });
      
      var joined = buildQuery.join(' && ');

      if (joined.length > 0 && eval(joined)) {
        return true;
      } else { 
        return false;
      }
    },
    
    filtersSubmit (params) {  
      this.getTransactions(params);
    },
    clear: function() {
      store.dispatch('resetFilterProperties');
      this.getTransactions();
    },
    handlePaginationChange(page_number) {
      this.getTransactions({
        ...this.filterProperties,
        page: page_number
      });
    },
    getTransactions: function(params) {
      const id = this.$route.params.id;
        
      if (id) {
        TransactionAPI.methods.getPayerVendorTransactions(id, params)
        .then(verResponse => {
        })
        .catch(error => {
            console.log('error', error);
        });
      }
    }
  },
  computed: {
    filterProperties: {
      get: function () {
        return store.state.filterProperties;
      },
      set: function (newValue) {
        store.state.filterProperties = newValue;
      }
    },
    payerVendorTransactionsIsReady () {
      if (this.axiosRequestAmount == 0) {
        return false
      }

      return true
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    customer_account: {
      get: function () {
        return store.state.customer_account;
      },
      set: function (newValue) {
        store.state.customer_account = newValue;
      }
    },
    rows() {
      return this.payerVendorTransactions.count;
    },
    payersListing: {
      // TODO: generate payer listing from currentTransaction data
      get: function () {
        return store.state.payersListing;
      },
      set: function (newValue) {
        store.state.payersListing = newValue;
      }
    },
    currentCustomer: {
      get: function () {
        return store.state.currentCustomer;
      },
      set: function (newValue) {
        store.state.currentCustomer = newValue;
      }
    },
    payerList: function() {
      return this.payersListing;
    },
    currentSettlement: {
      get: function () {
        return store.state.currentSettlement;
      },
      set: function (newValue) {
        store.state.currentSettlement = newValue;
      }
    },
    payerVendorTransactions: {
      get: function () {
        return store.state.payerVendorTransactions.results;
      },
      set: function (newValue) {
        store.state.payerVendorTransactions.results = newValue;
      }
    }
  },
};
</script>
<style scoped>
/*Injected Landing Page Css*/
/* @import '../../public/css/core.css';
@import '../../public/css/core_responsive.css';
@import '../../public/css/ggtooltip.css'; */
@import '../assets/css/table.css';

.rounded-pills {
  border-radius: 30px;
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
</style>
